import { defineStore } from 'pinia';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';

export const useStoreButtonTitles = defineStore('buttonTitles', {
  state: () => ({
    addCurrency: '',
    back: '',
    cancel: '',
    cashout: '',
    close: '',
    copy: '',
    buyCryptoCurrencyButton: '',
    showAllLevels: '',
    continue: '',
    deposit: '',
    exchange: '',
    getBonus: '',
    goToMobile: '',
    login: '',
    ok: '',
    playForFun: '',
    playNow: '',
    reset: '',
    rulesAndConditions: '',
    search: '',
    showLessGames: '',
    showMoreGames: '',
    signup: '',
    unlock: '',
    learnMore: '',
    emailSend: '',
    emailResend: '',
    transactionHistory: '',
    goToLobby: '',
    bonusTerms: '',
    forfeit: '',
    activate: '',
    save: '',
    next: '',
    goToLobbyButton: '',
    help: '',
    decline: '',
    accept: '',
    remove: '',
    noBonus: '',
    qrShow: '',
    qrHide: '',
    goToPersonalAccount: '',
    join: '',
    playForReal: '',
    confirm: '',
    retry: '',
    useBonusCode: '',
    contactSupport: '',
    apply: '',
    add: '',
    withdraw: '',
    locale: '',
    verifyPhoneNumber: '',
    anotherPaymentMethod: '',
    goToHistory: '',
    recall: '',
    goToVIP: '',
    submit: '',
    reject: '',
    moreInfo: '',
    closeMultislot: '',
    searchAnotherGame: '',
    play: '',
    yesBonusCancel: '',
    noBonusCancel: '',
    goToFAQ: '',
    deactivate: '',
    activeBonus: '',
    goToDeposit: '',
    deleteSavedCardYes: '',
    showAll: '',
    installApp: '',
    toActiveBonuses: '',
    restrictedSignupTerms: '',
    restrictedSignupSupport: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadButtonTitles() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('button-title')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
